import Summary from "@/pages/Summary/Summary";
import { ILang } from "../i18n";

const EN: ILang = {
  FilterDate: {
    Default: "Default",
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    ViewBy: "View by",
    ErrorSelectDateMessage:
      "Please choose a period of at least 3 days and maximum 15 days!"
  },
  Lang: {
    Code: "EN",
    TextEN: "English",
    TextVN: "Vietnamese"
  },
  Login: {
    ErrorEmail: "Please enter email",
    LoginDescription: "Enter your email and password to login",
    ButtonText: "Login"
  },
  Sidebar: {
    Overview: "Overview",
    Manage: "Manage",
    Account: "Account",
    Dashboard: "Dashboard",
    ManageUser: "Manage User",
    ManageCashflow: "Manage Cashflow",
    RecordingBalance: "Recording balance",
    AccountName: "Account Name",
    BankAccount: "Bank Account",
    ManageExchangeRate: "Manage Exchange Rate",
    Transaction: "Transaction",
    Setting: "Setting",
    Notification: "Notification",
    FAQ: "FAQ",
    Cashflow: "Cashflow",
    ManageAdminUser: "Manage Admin User",
    ManagePartnerUser: "Manage Partner User",
    Statistics: "Analytics",
    AdminStatistics: "Admin Analytics"
  },
  Modal: {
    CancelText: "Cancel",
    SubmitText: "Submit"
  },
  Setting: {
    AccountInformation: "Account Information",
    TimeRegister: "Account registered on",
    ModalTitle: "Change Password",
    ModalOldPassword: "Old password",
    ModalPassword: "New password",
    ModalOldPasswordPlaceholder: "Enter old password",
    ModalPasswordPlaceholder: "Enter new password",
    ModalConfirmPassword: "Confirm new password",
    UpdatePasswordSuccess: "Update Password successfully",
    UpdateFail: "Update Password failed!"
  },
  Role: {
    Owner: "Owner",
    Admin: "Admin",
    ViewReport: "ViewReport"
  },
  Common: {
    UpdateSuccess: "Update Success!",
    InsertNew: "Add new",
    Edit: "Edit",
    Delete: "Delete",
    Status: "Status",
    Update: "Update",
    DateCreated: "Date Created",
    RowPerPage: "Row per page",
    Of: "of",
    More: "more",
    Code: "Code",
    Name: "Name",
    NameValidate: "Please enter name",
    Description: "Description",
    Title: "Title",
    Content: "Content",
    DiscountPrice: "Discount price",
    Price: "Price",
    Type: "Type",
    Prominent: "Prominent",
    StartDate: "Start date",
    EndDate: "End date",
    Quantity: "Quantity",
    Product: "Product",
    Customer: "Customer",
    Detail: "View Detail",
    Cancel: "Cancel",
    Confirm: "Confirm",
    Inflow: "Inflow",
    Outflow: "Outflow",
    Active: "Active",
    Deactive: "Deactive",
    BankNumber: "Bank Number",
    Currency: "Currency",
    ApiError: "Error! Please try again later.",
    Amount: "Amount",
    AmountPlaceholder: "Enter amount",
    Search: "Search",
    Role: "Role",
    Date: "Date",
    LastName: "Lastname",
    FirstName: "Firstname",
    Password: "Password",
    Logout: "Logout account",
    PasswordValidate: "Please enter password",
    PasswordOldValidate: "Please enter your current password!",
    PasswordConfirmValidate: "Please enter correct password!",
    ResetPassword: "Reset password",
    UpdateCashflow: "Update Cashflow",
    AddMore: "Add More",
    TimeDefault: "Time default",
    AllAccountBank: "All account bank",
    CompanyName: "Company name",
    PhoneNumber: "Phone number",
    EnterPhoneNumber: "Enter phone number",
    QuantityMember: "Quantity member",
    Limit: "Limit",
    PercentComplete: "Percent complete",
    Close: "Close",
    Color: "Color",
    ExpectedTime: "Expected time",
    Hour: "Hour",
    Minute: "Minute",
    Processing: "Processing",
    SearchTasks: "Search tasks",
    SearchTaskAssignees: "Search Task Assignees",
    SearchByTime: "Search by Time",
    All: "All",
    CreatedBy: "Created by",
    At: "At",
    LastUpdated: "Last updated",
    NotSet: "Not set",
    TotalTime: "Total time",
    Used: "Used",
    UnexpectedError: "An unexpected error occurred. Please try again later.",
    NoDescription: "No description",
    CollapseDescription: "Collapse description",
    ExpandDescription: "Expand description",
    UploadFile: "Upload file",
    TaskList: "Task list",
    LoadMore: "Load more",
    EnterContent: "Enter content",
    Send: "Send",
    Reply: "Reply",
    NoData: "No Data",
    Creator: "Creator",
    Day: "Day",
    LoadingMore: "Loading more",
    To: "To",
    Undefined: "Undefined",
    Hello: "Hi",
    LoadingDataPleaseWait: "Loading data, please wait...",
    UserGuide: "User Guide",
    ClearSearch: "Clear search",
    SearchFoundResult: "Found {{count}} results",
    Today: "Today",
    Month: "Month",
    Week: "Week",
    List: "List",
    ListDay: "Day",
    From: "From"
  },
  Management: {
    Task: "Task",
    ContentTask:
      "Comprehensive task management that enables teams to organize work, assign responsibilities, and track progress toward timely and effective goal completion.",
    Feature: "Feature",
    SomePopularFeatures: "Some popular features",
    InternalAnnouncements: "Internal announcements",
    ContentInternalAnnouncements:
      "Easily keep everyone updated and connected with timely information across your organization.",
    CompanyRules: "Company rules",
    ContentCompanyRules:
      "Help employees understand company regulations, standards, and a unified workplace culture across the organization.",
    MeetingSchedule: "Meeting schedule",
    ContentMeetingSchedule:
      "Manage, organize, and track internal meetings to help teams collaborate effectively and stay on schedule.",
    LeaveManagement: "Leave management",
    ContentLeaveManagement:
      "Simplify the leave request, approval, and tracking process with transparency and convenience for every employee",
    ContentLinkCoDrive:
      "Securely store, share, and manage company documents in one centralized place — accessible anytime, anywhere.",
    ContentGoogleAds:
      "Manage, track, and optimize Google advertising campaigns intelligently — all in one platform.",
    ContentGoogleConsole:
      "A website management tool that helps you monitor, analyze, and improve SEO performance easily on the Google platform.",
    GoogleToolContent:
      "The project integrates two core Google digital marketing analytics and management tools, including Google Ads API (for managing paid advertising) and Google Search Console API (for monitoring organic search performance).",
    CustomerSupport: "Customer support",
    ContentCustomerSupport: "Provide user support and information assistance.",
    Workflow: "Workflow",

    AvailableWorkflows: "Available workflows",
    ClosedWorkflow: "Closed workflow",
    WorkflowCreatedbyMe: "Created by me",
    WorkflowManagement: "Workflow management",
    CreateNewWorkflow: "Create new workflow",
    UpdateWorkflow: "Update workflow",
    DuplicateWorkflow: "Duplicate workflow",
    DuplicateNewWorkflow: "Duplicate as a new workflow",
    PleaseEnterTheWorkflowCategoryName:
      "Please enter the workflow category name",
    NewWorkflowName: "New workflow name",
    ExportToExcel: "Export to excel",
    CloseWorkflow: "Close workflow",
    WorkflowName: "Workflow name",
    WorkflowCategory: "Workflow category",
    WorkflowAdministrators: "Workflow administrators",
    ContentWorkflowAdministrators:
      "The administrator can view all members’ tasks. You are set as the default administrator.",
    GroupCreateTask: "The Member group has permission to create new tasks.",
    ContentGroupCreateTask:
      "Members or member groups have permission to create tasks within the workflow.",
    PlacehoderGroupCreateTask: "Enter member or department name",
    WorkflowSupervisor: "Workflow Supervisor",
    ContentWorkflowSupervisor:
      "Members have permission to view and review all tasks, but they are not allowed to edit them.",
    AutomaticallyForwardTaskWhenReachingThisStage:
      "Automatically forward task when reaching this stage",
    WhenReachingTheSelectedStageTheTaskWillAutomaticallyMoveToAnotherWorkflow:
      "When reaching the selected stage, the task will automatically move to another workflow.",
    NoStagesAvailable: "No stages available",
    SelectWorkflow: "Select workflow",
    SelectTransitionStage: "Select transition stage",
    OtherOptions: "Other options",
    MemberGroupsWithPermissionToWiewTheWorkflow:
      "Member groups with permission to view the workflow",
    MembersOrMemberGroupsWhoCanSeeTheWorkflowInTheList:
      "Members or member groups who can see the workflow in the list",
    WorkflowUserGuide: "Workflow user guide",
    DetailedDescriptionOfTheWorkflow: "Detailed description of the workflow",
    DetailedWorkflowDescription: "Detailed workflow description",
    ReasonForTaskFailure: "Reason for task failure",
    PleaseProvideDetailedPossibleReasonsForTaskFailureIfAny:
      "Please provide detailed possible reasons for task failure, if any.",
    EnterAPossibleReasonForFailure: "Enter a possible reason for failure",
    PleaseEnterTheWorkflowName: "Please enter the workflow name",
    PleaseSelectTheWorkflowCategory: "Please select the workflow category",
    PleaseSelectAWorkflow: "Please select a workflow",
    PleaseSelectATransitionStage: "Please select a transition stage",
    CreateTask: "Create task",
    CreateContract: "Create Contract",
    CreateWorkflow: "Create workflow",
    AddStage: "Add stage",
    AddNewStage: "Add new stage",
    EditStage: "Edit stage",
    Stage: "Stage",
    StageName: "Stage name",
    PleaseEnterTheTaskName: "Please enter the task name",
    InvalidTime: "Invalid time",
    EditTask: "Edit task",
    UpdatePersonalDeadlines: "Update personal deadlines",
    PersonalDeadlines: "Personal deadlines",
    EditContract: "Edit contract",
    TaskName: "Task name",
    ContractName: "Contract name",
    ContractExecutor: "Contract executor",
    AssignTaskTo: "Assign task to",
    EnterMemberName: "Enter member name",
    TaskDescription: "Task description",
    ContractDescription: "Contract description",
    ShortTaskDescription: "Short task description",
    ShortContractDescription: "Short contract description",
    Follower: "Follower",
    ExpectedCompletionDate: "Expected completion date",
    ClickToSelectADate: "Click to select a date",
    ClickToSelectATime: "Click to select a time",
    Deadline: "Deadline",
    NoDeadline: "No deadline",
    Expectation: "Expectation",
    Attachments: "Attachments",
    AttachUpTo10Files: "Attach up to 10 files",
    DragFilesHere: "Drag files here",
    OrSelectFilesFromYourComputer: "Or select files from your computer",
    NumberOfFilesExceeded: "Number of files exceeded",
    MaximumFileUpload:
      "You have uploaded a file exceeding the allowed size (maximum 15MB)",
    InvalidFileFormat: "You have uploaded an invalid file format",
    StageAdministrator: "Stage Administrator",
    DefaultFollowersOfTheStage: "Default followers of the stage",
    StageAssignee: "Stage assignee",
    HowIsTheTaskAssignedOrReassigned: "How is the task assigned or reassigned?",
    StageCompletionGuide: "Instructions for completing stages in a task",
    StageCompletionInstructions: "Explanation on how to complete a stage",
    RetainPreviousAssignee: "Keep the same assignee from the previous stage",
    ReturnToFirstAssignee: "Reassign to the original task assignee",
    UnassignedStageManagerDecides: "No assignee – Let the stage manager decide",
    DecisionByStageMover: "Let the stage transitioner decide",
    RandomlyAssign: "Assign the task to a random member",
    ReturnToPreviousStageAssignee:
      "Reassign to the assignee from a previous stage",
    PleaseEnterTheStageName: "Please enter the stage name",
    PleaseSelectTheTaskAssignmentMethod:
      "Please select the task assignment method",
    PleaseSelectAStage: "Please select a stage (required)",
    PleaseEnterTheCorrectFormat: "Please enter the correct format, e.g., 12:30",
    ConfirmWorkflowClosure: "Confirm workflow closure",
    AreYouSureYouWantToCloseThisWorkflow:
      "Are you sure you want to close this workflow?",
    CurrentStage: "Current stage",
    TimeSpent: "Time spent",
    NextStage: "Next stage",
    TaskInformation: "Task information",
    MovedToStageAt: "Moved to stage at",
    TaskFollower: "Task follower",
    EditFollowers: "Edit followers",
    StageFollower: "Stage follower",
    WorkflowFollower: "Workflow follower",
    StageProgress: "Stage progress",
    WaitingStage: "Queued stage",
    SkippedStage: "Skipped stage",
    Actual: "Actual",
    Duration: "Duration",
    TaskMarkedAsFailed: "The task has been marked as failed.",
    TaskMovedToTheNextStage: "The task has been moved to the next stage.",
    TaskTransitionFailed: "Task transition failed",
    EnterTheReasonForFailure: "Enter the reason for failure",
    PleaseEnterTheReasonForFailure: "Please enter the reason for failure.",
    Transition: "Transition",
    MarkAsFailed: "Mark as failed",
    StageDueDate: "Stage due date",
    Remaining: "Remaining",
    NoTasksYet: "No tasks yet!",
    Done: "Done",
    Fail: "Fail",
    Cancel: "Cancel",
    TableView: "Table view",
    GridView: "Grid view",
    AddAStageToTheLeft: "Add a stage to the left",
    AddAStageToTheRight: "Add a stage to the right",
    DeleteStage: "Delete stage",
    ConfirmTaskDeletion: "Confirm task deletion",
    ConfirmDeletionOfThisTask: "Are you sure you want to delete this task?",
    AreYouSureYouWantToDeleteThisStage:
      "Are you sure you want to delete this stage?",
    ConfirmStageDeletion: "Confirm stage deletion",
    OpenInANewTab: "Open in a new tab",
    BackToPreviouStage: "Go back to the previous stage",
    ReassignToSomeoneElse: "Reassign to someone else",
    DeleteTask: "Delete task",
    SelectTaskAssignees: "Select task assignees",
    PleaseSelectTaskAssignees: "Please select task assignees",
    EditDescription: "Edit task description",
    InProgress: "InProgress",
    Assign: "Assign",
    NotAssigned: "Not Assigned",
    TaskAssignedToWhichStage: "At which stage should the task be assigned?",
    ImmutableDeadline: "Deadline cannot be adjusted",
    InsertAt: "Insert at",
    InsertBeforeDoneStage: "Before the Done stage",
    AdvancedOptions: "Advanced options",
    AllowExecutorToUpdateNextStageDuration:
      "Allow executor to update the duration for the next stage",
    SkipSunday: "Skip Sundays",
    RequireFinishPreviousTasks:
      "Require all previous tasks to be completed before moving to the next stage",
    NotRequired: "Not required",
    Required: "Required",
    AllowMembersOrFollowersToAddTasksInThisStage:
      "Allow task viewers or followers to add new tasks in this stage",
    Price: "Price",
    Deposit: "Deposit",
    WorkflowIconName: "Workflow Icon",
    WorkflowIconDescription: "Workflow Icon Description",
    WorkflowIconPlaceholder: "Workflow Icon Placeholder"
  },
  Comment: {
    Comment: "Comment",
    EditComment: "Edit comment"
  },
  Chat: {
    GroupNew: "New chat group",
    SearchForChatGroup: "Search for chat group",
    NewChat: "New chat",
    Messages: "Messages",
    ConversationName: "Conversation name",
    CreateGroup: "Create group",
    NoMessagesYet: "No messages yet",
    SeenAt: "Seen at",
    TypeYourMessage: "Type your message",
    PleaseEnterTheGroupName: "Please enter the group name",
    EditConversationName: "Edit conversation name"
  },
  Summary: {
    Title: "Dashboard",
    Loading: "Loading...",
    Activity: "Activity",
    Notifications: "Notifications",
    NotificationsLoading: "Loading...",
    NotificationsNoMore: "No more notifications",
    Traffic: "Traffic",
    CompletionRate: "Completion rate",
    TaskCount: "Task count",
    SearchPlaceholder: "Search...",
    NoWorkflow: "No workflow",
    Cards: {
      TotalTasks: "Total tasks",
      CompletedTasks: "Completed tasks",
      FailedTasks: "Failed tasks",
      InProgressTasks: "Tasks in progress",
      CancelledTasks: "Cancel Tasks"
    },
    Sort: {
      Default: "Sort by",
      TotalDesc: "Total (High → Low)",
      TotalAsc: "Total (Low → High)",
      InProgressDesc: "In progress (High → Low)",
      InProgressAsc: "In progress (Low → High)",
      FailedDesc: "Failed (High → Low)",
      FailedAsc: "Failed (Low → High)",
      CompletedDesc: "Completed (High → Low)",
      CompletedAsc: "Completed (Low → High)"
    },
    Table: {
      Performer: "Assignee",
      InProgress: "In progress",
      Failed: "Failed",
      Completed: "Completed",
      Cancelled: "Canceled"
    }
  },
  User: {
    DoYouWantToChangeYourProfilePicture:
      "Do you want to change your profile picture?",
    PleaseEnterYourNewPassword: "Please enter your new password",
    PleaseEnterYourCurrentPassword: "Please enter your current password",
    ConfirmUpdate: "Are you sure you want to change your personal information?",
    ChangeIt: "Are you sure you want to change it?",
    AccountManagement: "Account management",
    AccountInformation: "Account information",
    NoEmployeeIDYet: "No employee ID yet",
    ChangePassword: "Change Password",
    Position: "Job Title",
    DirectManager: "Direct manager",
    NoManagerAssigned: "No manager assigned",
    PersonalContactInformation: "Personal contact information",
    EditAccountInformation: "Edit account information",
    NoInformationAvailable: "No information available",
    RemainingLeaveDays: "Remaining leave days",
    Department: "Department",
    DirectReports: "Direct reports",
    Address: "Address",
    EnterAddress: "Enter address",
    EditInformation: "Edit information",
    EditDirectManager: "Edit direct manager",
    AdminPermissions: "Admin permissions",
    UpdateAnnuaLeave: "Update annual leave",

    AccountManagementMemberTitle: "Account management | Members",
    SearchMembersPlaceholder: "Search members...",
    AddAccount: "Add account",
    CreateNewAccountTitle: "Create new account",

    LastAndMiddleNameLabel: "Last and middle name",
    EnterLastAndMiddleName: "Enter last and middle name",
    FirstNameLabel: "First name",
    EnterFirstName: "Enter first name",
    UsernameLabel: "Username",
    EnterUsername: "Enter username",
    EmailLabel: "Email",
    EnterEmailAddress: "Enter email address",

    AccountType: "Account type",
    PleaseSelect: "Please select",
    PleaseSelectAccountType: "Please select an account type",
    TypeToSearch: "Type to search",
    EmployeeLabel: "employee",

    PleaseEnterLastAndMiddleName: "Please enter your last and middle name",
    PleaseEnterFirstName: "Please enter your first name",
    PleaseEnterUsername: "Please enter your username",
    InvalidEmailFormat: "Invalid email format",
    PleaseEnterEmailAddress: "Please enter your email address",

    CreateAccountSuccess: "Account created successfully"
  },
  Department: {
    AccountManagementGroupTitle: "Account management | Groups",

    SearchGroupsPlaceholder: "Search groups...",

    CreateUserGroupButton: "Create user group",
    CreateUserGroupModalTitle: "Create user group",

    GroupNameLabel: "Group name",
    EnterGroupName: "Enter group name",

    UsernameLabel: "Username",
    EnterGroupUsername: "Enter group username",

    GroupAdminLabel: "Group admin",
    MembersLabel: "Members",
    MembersNoteCanBeAddedLater: "Members can be added later",

    TypeToSearchPlaceholder: "Type to search",
    AddMembersPlaceholder: "Add members",

    SearchNoResultTitleDepartment: "department",

    EmptyList: "Empty list",

    AdminLabelUppercase: "ADMIN",
    NoAdminYet: "No admin assigned",

    MembersSuffix: "members",
    NoMembersYet: "No members yet",

    LoadMore: "Load more",

    PleaseEnterGroupName: "Please enter group name",
    PleaseEnterUsername: "Please enter username",
    PleaseSelectGroupAdmin: "Please select a group admin",

    // ===== For company detail screen =====
    CompanyNameLabel: "Company name",
    CompanyNamePlaceholder: "Enter company name",

    TaxIdentificationNumberLabel: "Tax identification number",
    TaxIdentificationNumberPlaceholder: "Enter tax identification number",

    NumberOfUsersCreatedLabel: "Maximum users allowed",
    NumberOfUsersCreatedPlaceholder: "Enter number of users allowed",

    ExpirationDateLabel: "Expiration date",
    ExpirationDatePlaceholder: "Tap to select a date",

    ConnectionStringLabel: "Key",
    ConnectionStringPlaceholder: "Connection key",

    EditCompanyInfoModalTitle: "Edit company information",
    AddMembersModalTitle: "Add members",

    DeleteMembersButton: "Remove members",
    DeleteCompanyButton: "Delete company",

    ConfirmDeleteCompanyTitle: "Delete this company?",
    ConfirmDeleteCompanyContent:
      "Are you sure you want to delete this company?",
    DeleteCompanySuccessMessage: "Company deleted successfully",

    PleaseEnterCompanyName: "Please enter company name",
    PleaseEnterConnectionString: "Please enter connection string",
    PleaseEnterPhoneNumber: "Please enter phone number",
    PleaseEnterTaxIdentificationNumber:
      "Please enter tax identification number",
    PleaseEnterAddress: "Please enter address",
    PleaseEnterNumberOfUsersCreated: "Please enter number of users allowed",
    PleaseEnterEmail: "Please enter email address",
    InvalidEmailFormat: "Invalid email format",
    PleaseSelectMembers: "Please select members",

    EditGroupInfoModalTitle: "Edit group information",

    AddMembersButton: "Add members",
    DeleteGroupButton: "Delete group",

    ConfirmDeleteDepartmentTitle: "Delete this group?",
    ConfirmDeleteDepartmentContent:
      "Are you sure you want to delete this group?",
    DeleteDepartmentSuccessMessage: "Group deleted successfully",

    NoGroupAdminYet: "No group admin assigned",
    EditLabel: "Edit",
    SearchNewGroupAdminPlaceholder: "Type to search for a new group admin",
    AddMultipleMembersInfo: "You can add multiple members at once"
  },
  UserDetail: {
    EmployeeInfoTitle: "Employee information",
    EmailLabel: "Email",
    NoInfo: "No information",
    DirectManagerLabel: "Direct manager",
    NoManagerYet: "No manager assigned",

    // Toast & confirm
    ToastUpdateSuccess: "Updated successfully",
    ToastErrorDefault: "An error occurred",
    ToastDeactivateSuccess: "This account has been deactivated",

    ConfirmDeactivateTitle: "Deactivate this account?",
    ConfirmDeactivateContent:
      "Are you sure you want to deactivate this account?",
    ConfirmDeactivateSubmitText: "Confirm",

    // Buttons
    DeactivateAccountButton: "Deactivate account",
    ModalSubmitText: "Update",
    ModalCancelText: "Cancel",

    // Checkboxes / flags
    TimeOffCheckboxLabel: "Enable leave tracking",

    // Basic info
    EmployeeCodeLabel: "Employee ID",
    EmployeeCodePlaceholder: "M000",

    UsernameLabel: "Username",
    UsernamePlaceholder: "Enter username",

    LastNameLabel: "Last name & middle name",
    LastNamePlaceholder: "Enter last name & middle name",

    FirstNameLabel: "First name",
    FirstNamePlaceholder: "Enter first name",

    PositionLabel: "Job title",
    PositionPlaceholder: "Enter job title",

    DepartmentLabel: "Department",
    DepartmentPlaceholder: "Type to search",

    PhoneNumberLabel: "Phone number",
    PhoneNumberPlaceholder: "Enter phone number",

    BirthDateLabel: "Date of birth",

    AddressLabel: "Address",
    AddressPlaceholder: "Enter address",

    // Change password
    NewPasswordLabel: "New password",
    NewPasswordPlaceholder: "Enter new password",

    // Change manager
    SelectDirectManagerTitle: "Select direct manager",
    CurrentManagerLabel: "Current manager",
    NewManagerLabel: "Select new manager",
    SearchManagerPlaceholder: "Type to search",

    // Roles & permissions
    RoleSelectLabel: "User role",
    RoleSelectPlaceholder: "Please select",

    PermissionSectionTitle: "Access permissions",
    PermissionSelectAllLabel: "Select all",

    // Time off
    AnnualLeaveLabel: "Annual leave days",
    AnnualLeavePlaceholder: "Enter number of days",

    // Validation messages
    PleaseEnterLastName: "Please enter last name & middle name",
    PleaseEnterFirstName: "Please enter first name",
    PleaseEnterUsername: "Please enter username",
    PleaseEnterNewPassword: "Please enter a new password",
    PleaseSelectManager: "Please select a manager",
    EmptyList: "Empty list",
    SelectedCount: "Selected {{count}}",
    FullNameHeader: "Full name",
    AccountHeader: "Account",
    InfoHeader: "Information",
    DeleteButtonText: "Delete",
    NoAnnualLeaveLabel: "None",
    DaySuffix: "days",
    ConfirmRemoveFromGroupTitle: "Remove members?",
    ConfirmRemoveFromGroupContent:
      "Are you sure you want to remove the selected members from this group?"
  },
  TimeOff: {
    PageTitle: "Time off",
    RequestListTitle: "Request list",

    CreateRequestButton: "Create request",
    CreateRequestMenuItem: "Create request",
    ExportExcelMenuItem: "Export monthly Excel",

    TabMyTimeOff: "My time off",
    TabPending: "Pending",
    TabManagerApproved: "Manager approved",
    TabCEOApproved: "Approved",
    TabRejected: "Rejected",
    TableHeaderIndex: "#",
    TableHeaderTitle: "Title",
    TableHeaderCreator: "Requester",
    TableHeaderDate: "Requested dates",
    TableHeaderStatus: "Status",

    ToolbarSelectedCount: "{{count}} request(s)",
    ToolbarApproveAll: "Approve all",

    EmptyText: "No data",
    CreateModalTitle: "Create leave request",
    CreateModalSubmit: "Save",
    CreateModalCancel: "Cancel",
    CreateModalPastDateWarning:
      "[Required] You cannot request days in the past",

    CreateModalTitleLabel: "Title",
    CreateModalTitleHintPrefix: "Format:",
    CreateModalTitleHintSample: "LEAVE REQUEST - FULL NAME - EMPLOYEE CODE",
    CreateModalTitlePlaceholder: "Title",

    CreateModalTypeLabel: "Request type",

    CreateModalDescriptionLabel: "Request description",
    CreateModalDescriptionPlaceholder: "Describe your request",

    CreateModalSessionLabel: "Leave sessions",
    CreateModalSelectDatePlaceholder: "Tap to select date",

    CreateModalAddNextDay: "+ADD NEXT DAY",

    CreateModalSuccessMessage: "Leave request created successfully",
    TypeAnnualLeaveLess3Days: "Annual leave under 3 days",
    TypeAnnualLeaveMore3Days: "Annual leave from 3 days",
    TypeUnpaidLeaveLess3Days: "Unpaid leave under 3 days",
    TypeUnpaidLeaveMore3Days: "Unpaid leave from 3 days",
    Validation: {
      TitleRequired: "Please enter a title",
      TypeRequired: "Please select a request type",
      DescriptionRequired: "Please enter a reason",
      InvalidTime: "Invalid time selected",
      TimeRequired: "Please select a time",
      TimeOffTypeRequired: "Please select a leave type"
    }
  },
  Meeting: {
    MeetingManagement: "Meeting Management",
    CreateButton: "Book a meeting",
    CreateModalTitle: "Create new meeting booking",
    CreateModalSubmit: "Submit",
    CreateModalCancel: "Cancel",

    TitleLabel: "Title",
    TitlePlaceholder: "Title",
    DescriptionLabel: "Description",
    DescriptionPlaceholder: "Description",

    RoomLabel: "Meeting room",
    RoomPlaceholder: "Please select",
    RoomErrorText: "Please select a meeting room",

    StartTimeLabel: "Start time",
    EnterStartTimeLabel: "Please enter the start date.",

    EndTimeLabel: "End time",
    EnterEndTimeLabel: "Please enter the end date.",

    ParticipantsLabel: "Participants",
    ParticipantsPlaceholder: "Type to select participants...",
    OtherParticipantsLabel: "Other participants",
    OtherParticipantsInfo: "Participants outside the company",
    OtherParticipantsPlaceholder: "Customers, partners, ...",

    FilterSectionTitle: "Legend",
    MyBookingsTitle: "My bookings",

    ToastCreateSuccess: "Meeting booked successfully",

    ValidationTitleRequired: "Please enter a title",
    ValidationDescriptionRequired: "Please enter a description",
    ValidationRoomRequired: "Please select a meeting room",
    ValidationParticipantsRequired: "Please select at least one participant",
    EventDetail: {
      TooltipDeleteSchedule: "Delete meeting schedule",
      TooltipEditSchedule: "Edit schedule information",

      ModalEditTitle: "Edit meeting registration",
      ModalSubmit: "Update",
      ModalClose: "Cancel",

      FieldStatus: "Status",
      FieldDateTime: "Date & Time",
      FieldLocation: "Location",
      FieldHost: "Host",
      FieldParticipants: "Participants",
      FieldOtherParticipants: "Other participants",

      PlaceholderCancelReason: "Enter a reason",

      Form: {
        Title: "Title",
        TitlePlaceholder: "Title",
        Description: "Description",
        DescriptionPlaceholder: "Description",
        Room: "Meeting room",
        RoomPlaceholder: "Please select",
        RoomRequiredMessage: "Please select a meeting room",
        StartTime: "Start time",
        EndTime: "End time",
        Participants: "Participants",
        ParticipantsPlaceholder: "Type a name to select participants",
        OtherParticipants: "Other participants",
        OtherParticipantsInfo: "Participants from outside the company",
        OtherParticipantsPlaceholder: "Clients, ..."
      },

      Validation: {
        TitleRequired: "Please enter a title",
        DescriptionRequired: "Please enter a description",
        StartDateRequired: "Please enter a start time",
        ParticipantsRequired: "Please select at least one participant"
      },

      Actions: {
        Approve: "Approve",
        Reject: "Reject",
        Complete: "Finish",
        CancelRegister: "Cancel registration",
        Cancel: "Cancel",
        ConfirmCancel: "Confirm cancellation",
        Confirm: "Confirm"
      },

      Confirm: {
        ApproveTitle: "Do you want to approve this registration?",
        ApproveContent: "Are you sure you want to approve this registration?",
        RejectTitle: "Do you want to reject this registration?",
        RejectContentLine1: "Do you want to reject this registration?",
        RejectContentLine2:
          "This registration will be deleted after confirmation.",
        CompleteTitle: "Do you want to end this meeting?",
        CompleteContent:
          "You will not be able to use this meeting room after confirmation.",
        RequestCancelTitle: "Do you want to request a cancellation?",
        RequestCancelContent:
          "Are you sure you want to request to cancel this registration?",
        ApproveCancelTitle: "Do you want to approve this cancellation request?",
        ApproveCancelContent:
          "Are you sure you want to approve this cancellation request?",
        DeleteTitle: "Do you want to delete this registration?",
        DeleteContent: "This registration will be deleted after confirmation.",
        SubmitText: "Confirm"
      },

      Messages: {
        UpdateSuccess: "Updated successfully",
        UpdateError: "An error has occurred",
        DeleteSuccess: "Registration has been deleted",
        GenericError: "An error occurred"
      }
    }
  },
  MeetingStatus: {
    Pending: "Pending",
    Confirmed: "Approved",
    Cancel: "Cancelled",
    WaitCancel: "Awaiting cancellation",
    Completed: "Completed",
    Unknown: "Unknown"
  },
  TimeOffStatus: {
    ManagerApprove: "Approved by manager",
    CEOApprove: "Approved",
    Pending: "Pending approval",
    NotApprove: "Rejected",
    Cancelled: "Cancelled",
    TeamLeaderApprove: "Approve by team leader"
  },
  TimeOffDetail: {
    StatusLabel: "Status",
    StatusUpdateSuccess: "Status has been updated",
    StatusUpdateErrorDefault: "An error occurred while updating status",

    DeleteSuccess: "Request has been deleted",
    DeleteErrorDefault: "An error occurred while deleting the request",

    ApproveButton: "Approve",
    RejectButton: "Reject",
    DeleteButton: "Delete request",

    MainInfoSectionTitle: "MAIN INFORMATION",
    MainInfoIdPrefix: "ID:",

    CreatedByLabel: "Created by",
    SalaryAffectLabel: "Attendance effect",
    SalaryAffectYes: "Counted as working day",
    SalaryAffectNo: "Not counted as working day",
    ContentLabel: "Content",

    TimeOffSectionTitle: "TIME OFF SESSIONS"
  },
  Docs: {
    SearchPlaceholder: "Search documents...",
    Unread: "Unread",
    LoadMore: "Show older documents",
    EmptyTitle: "No content to display",
    DocumentType: {
      Title: "Document types",
      AddNew: "Add new",
      ActionActivate: "Activate",
      ActionEdit: "Edit",
      ActionDelete: "Delete",
      ConfirmDeleteTitle: "Are you sure you want to delete?",
      ConfirmDeleteContent:
        "You will not be able to restore this after confirming.",
      ConfirmToggleTitle: "Are you sure you want to change the status?",
      ConfirmToggleContent: "The status will be updated after you confirm.",
      ConfirmButton: "Confirm",
      ErrorCommon: "An error has occurred",
      SuccessUpdate: "Updated successfully",
      DeactivatePrefix: "Deactivate"
    },
    DocumentForm: {
      Document: "Document",
      TitleCreate: "CREATE NEW DOCUMENT",
      TitleEdit: "EDIT DOCUMENT",
      LabelNumberIdentifier: "Number / Identifier",
      PlaceholderNumberIdentifier: "Number / Identifier",
      LabelTitle: "Title",
      PlaceholderTitle: "Notification title",
      LabelIssueDate: "Issue date",
      LabelExpireDate: "Expiration date",
      LabelContent: "Content",
      PlaceholderContent: "Enter content...",
      ErrorTitleRequired: "Please enter the title",
      ErrorContentRequired: "Please enter the content",
      ErrorIssueDateRequired: "Please select the issue date",
      LabelReceiver: "Recipients",
      PlaceholderReceiver: "Type a name to select recipients...",
      LabelSendAllCompany: "Send to entire company",
      LabelDocumentType: "Document type",
      PlaceholderSelect: "Please select",
      ErrorDocumentTypeRequired: "Please select a document type",
      LabelStatus: "Status",
      PlaceholderSelectStatus: "Please select",
      LabelTags: "Tags",
      PlaceholderTags: "Tags",
      AttachmentTitle: "Attachments",
      AttachmentInfo: "Attach up to 10 files",
      AttachmentTooltipDelete: "Remove attachment",
      AttachmentSelectButton: "Select attachments",
      DeleteFilesSuccess: "Updated successfully",
      DeleteFilesError: "An error has occurred, please try again",
      ButtonCancel: "Cancel",
      ButtonUpdate: "Update",
      ButtonCreate: "Create"
    },
    DocumentTypeForm: {
      TitleEdit: "Edit document type",
      TitleCreate: "Create document type",
      LabelName: "Document type name",
      PlaceholderName: "Enter document type name",
      LabelActive: "Active",
      Processing: "Processing...",
      ButtonCancel: "Cancel",
      ButtonUpdate: "Update",
      ButtonCreate: "Create"
    },
    Admin: {
      ButtonDocumentType: "Document types",
      ButtonCreateDocument: "Create new document",
      TableHeaderDocument: "DOCUMENT",
      TableHeaderStatus: "STATUS",
      TableHeaderType: "TYPE",
      TableHeaderTime: "TIME",
      LabelIssueDate: "Issue date",
      LabelExpireDate: "Expiration date",
      NoInfo: "No information",
      TooltipEdit: "Edit information",
      TooltipViewDetail: "View details",
      TooltipDelete: "Delete document",
      ConfirmDeleteTitle: "Are you sure you want to delete this document?",
      ConfirmDeleteContent:
        "You will not be able to undo this action after confirming",
      ConfirmDeleteSubmit: "Confirm",
      UploadError: "An error occurred while uploading files, please try again",
      EmptyTitle: "No documents have been created yet",
      ErrorNoDocTypeNoPermission:
        "You cannot create a document when there is no document type. If you do not have permission, please contact the administrator to be granted access.",
      LoadingData: "Loading data...",
      UpdateSuccess: "Updated successfully",
      CreateSuccess: "Created successfully",
      CommonError: "An error has occurred, please try again"
    },
    Status: {
      PendingRelease: "Pending release",
      Released: "Released",
      Revocation: "Revoked",
      Unknown: "Unknown"
    },
    DownloadFileTooltip: "Download document",
    IssueDate: "Issue date:",
    ExpirationDate: "Expiration date:",
    NoExpirationInfo: "No information",
    AttachmentsTitle: "ATTACHMENTS"
  },
  Rules: {
    Title: "Rules",
    Buttons: {
      EditRules: "Edit office rules",
      CancelChanges: "Discard changes",
      UpdateRules: "Update rules"
    },
    Placeholder: {
      EnterRules: "Please enter office rules..."
    },
    Empty: {
      NoRules: "No rules available",
      NoData: "No information"
    },
    Messages: {
      UpdateSuccess: "Updated successfully",
      UpdateError: "An error has occurred"
    }
  },
  TimeOffType: {
    Title: "Leave types",
    Tabs: {
      Types: "Leave types",
      MailCC: "Mail CC"
    },
    Loading: {
      Data: "Loading data..."
    },
    Table: {
      Columns: {
        Name: "Leave type name",
        Calculation: "Calculation",
        Actions: "Actions"
      },
      Operation: {
        Minus: "Deduct from annual leave",
        NotOperation: "Do not deduct from annual leave"
      }
    },
    Buttons: {
      CreateType: "Add leave type",
      Delete: "Delete",
      Edit: "Edit",
      AddMail: "Add mail"
    },
    MailCC: {
      DefaultLabel: "Default CC users:",
      EmptyList: "No data"
    },
    Modal: {
      TitleEdit: "Edit leave type",
      TitleCreate: "Create leave type",
      Submit: "Confirm",
      Close: "Cancel",
      Fields: {
        NameLabel: "Leave type name",
        NamePlaceholder: "Enter leave type name",
        OperationLabel: "Deduct from annual leave",
        OperationYes: "Yes",
        OperationNo: "No"
      },
      Validation: {
        NameRequired: "Please enter a leave type name",
        OperationRequired: "Please select a type"
      }
    }
  },
  MeetingRoom: {
    Approve: {
      Sidebar: {
        Title: "MEETING ROOMS",
        TooltipDeleteRoom: "Hold to delete",
        ButtonCreateRoom: "Add meeting room"
      },
      TodaySchedule: {
        Title: "TODAY'S MEETINGS"
      },
      Tabs: {
        Pending: "Pending approval",
        WaitCancel: "Pending cancel approval",
        Confirmed: "Approved",
        Completed: "Completed"
      },
      List: {
        MonthTitle: "Month",
        NoRoomInformation: "No information",
        NoRegistrantData: "No data"
      },
      CreateRoomModal: {
        Title: "Create meeting room",
        Submit: "Create",
        Fields: {
          NameLabel: "Room name",
          NamePlaceholder: "Room name",
          DescriptionLabel: "Description",
          DescriptionPlaceholder: "Description",
          LocationLabel: "Location",
          LocationPlaceholder: "Location"
        },
        Validation: {
          NameRequired: "Please enter room name",
          LocationRequired: "Please enter location",
          DescriptionRequired: "Please enter description"
        }
      },
      Messages: {
        CreateSuccess: "Room created successfully",
        RoomDeleted: "Meeting room has been deleted",
        RegisterDeleted: "Registration has been deleted",
        UpdateSuccess: "Updated successfully",
        GenericError: "An error has occurred"
      },
      Confirm: {
        DeleteRoomTitle: "Do you want to delete this meeting room?",
        DeleteRoomContent: "Are you sure you want to delete this meeting room?",
        DeleteRoomSubmit: "Confirm",

        RejectTitle: "Do you want to reject this registration?",
        RejectContentLine1: "Do you want to reject this registration?",
        RejectContentLine2:
          "This registration will be removed after you confirm",
        RejectSubmit: "Confirm",

        ApproveTitle: "Do you want to approve this registration?",
        ApproveContent: "Are you sure you want to approve this registration?",
        ApproveSubmit: "Approve",

        CancelRequestTitle: "Approve the cancellation request?",
        CancelRequestContent:
          "Are you sure you want to approve this cancellation request?",
        CancelRequestSubmit: "Confirm",

        CompleteTitle: "Do you want to end this meeting?",
        CompleteContent:
          "You will not be able to use this room after confirming",
        CompleteSubmit: "Confirm"
      },
      Buttons: {
        Reject: "Reject",
        Approve: "Approve",
        ConfirmCancel: "Confirm",
        Complete: "Complete"
      }
    }
  },
  Header: {
    Profile: {
      Account: "Account",
      Support: "Support"
    },
    Logout: {
      ConfirmTitle: "Do you want to log out?",
      ConfirmContent: "Are you sure you want to log out of this account?",
      Button: "Log out"
    },
    Notifications: {
      Title: "Notifications ({{count}})",
      ReadAllTooltip: "Mark all as read",
      ReadAllConfirmTitle: "Mark all notifications as read?",
      ReadAllConfirmContent:
        "Are you sure you want to mark all notifications as read?",
      Empty: "No notifications",
      LoadMore: "Show older notifications"
    }
  },
  Account: {
    Nav: {
      Personal: "Personal",
      Member: "Employees",
      Group: "Teams",
      Company: "Company",
      Home: "Home"
    }
  },
  Gads: {
    Button: {
      Update: "Update GAds"
    },
    Modal: {
      Title: "Update GAds"
    },
    Field: {
      GoogleAds: "Google Ads"
    },
    Validate: {
      IframeRequired: "Please enter Google Ads iframe"
    }
  },
  Gcsl: {
    Button: {
      Update: "Update Console"
    },
    Modal: {
      Title: "Update Console"
    },
    Field: {
      GoogleAds: "Google Console"
    },
    Validate: {
      IframeRequired: "Please enter Google Console iframe"
    }
  },
  Booking: {
    Calendar: {
      NoEventsText: "No events"
    },
    MobileList: {
      Today: "Today",
      Meeting: "meetings"
    },
    Validation: {
      RoomNameRequired: "Please enter room name",
      LocationRequired: "Please enter location",
      DescriptionRequired: "Please enter description"
    },
    Messages: {
      ConfirmChangeTitle: "Do you want to change the time to",
      ConfirmStart: "Start",
      ConfirmEnd: "End",
      ConfirmButtonText: "Confirm",
      UpdateSuccess: "Updated successfully!",
      UpdateError: "An error occurred"
    }
  },
  TaskUpdateModal: {
    UpdateTaskSuccess: "Task updated successfully",
    ModalTitle: "Update task",
    ButtonUpdate: "Update",
    ButtonCancel: "Cancel",
    LabelTaskName: "Task name",
    PlaceholderTaskName: "Task name",
    LabelAssignTo: "Assign to",
    PlaceholderAssignTo: "Use @ to tag a member to assign the task",
    LabelDescription: "Task description",
    InfoDescription: "Short description of the task",
    PlaceholderDescription: "Short description of the task",
    LabelComment: "Comment",
    PlaceholderComment: "Write your comment",
    LabelAttachments: "Attachments",
    InfoAttachments: "Attach up to 10 files",
    TitleAttachments: "Attachments",
    EditTitleAttachments: "Edit Attachments",
    ValidateTaskName: "Please enter the task name",
    ValidateAssign: "Please select a task assignee"
  },
  TimeOffMailCC: {
    ModalTitle: "Update default CC for leave requests",
    SubmitText: "Confirm",
    CancelText: "Cancel",
    LabelCC: "Default CC recipients",
    InfoMax: "Maximum 10",
    PlaceholderEmail: "Enter email address",
    AddMailButton: "+Add email",
    ErrorAtLeastOneCC: "Please add at least one default CC recipient",
    DefaultSuccessMessage: "Updated successfully"
  },
  DeleteTimeOffType: {
    ModalTitle: "Confirm delete leave type",
    SubmitText: "Confirm",
    CancelText: "Cancel",
    ConfirmDeleteLabel: "Confirm delete",
    SuccessMessage: "Deleted successfully"
  },
  Payroll: {
    Title: "Payroll",
    FileName: "File name",
    Email: "Email",
    Attachments: "Attachments",
    SendPayroll: "Send payroll",
    CreatedDate: "Date sent",
    Modal: {
      TitleCreate: "Payroll attachments",
      ButtonSend: "Send"
    }
  },
  OpenAiChat: {
    Greeting: "Hello 👋 How can I help you?",
    Placeholder:
      "Type a message... (Enter to send, Shift + Enter for new line)",
    Uploading: "Uploading...",
    UploadSuccess: "Uploaded successfully.",
    UploadError: "Upload failed.",
    NoFiles: "No files uploaded.",
    DocsTitle: "Analyzed documents",
    DocsDesc: "Select docx files to upload for AI reading.",
    UploadBtn: "Upload",
    DeleteSuccess: "File deleted successfully",
    AskHint:
      "Tip: Type a question, select files and click Upload so AI can read your documents.",
    WaitingResponse: "⏳ Waiting for response...",
    ErrorResponse: "❌ Error receiving AI response",
    InvalidFile: "Only .doc and .docx files are supported"
  }
};

export default EN;
